import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store } from './app/store'
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import { HeaderProvider } from './context/HeaderContext';
import { WebinarProvider } from './pages/Webinar/context/WebinarContext';
import { PixelProvider } from './pages/Context/PixelContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HeaderProvider>
      <WebinarProvider>
        <PixelProvider>
          <App />
        </PixelProvider>
      </WebinarProvider>
    </HeaderProvider>
  </React.StrictMode>
);